import { render } from "./ValidationResults.vue?vue&type=template&id=4f27be59&scoped=true"
import script from "./ValidationResults.vue?vue&type=script&lang=js"
export * from "./ValidationResults.vue?vue&type=script&lang=js"

import "./ValidationResults.vue?vue&type=style&index=0&id=4f27be59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f27be59"]])

export default __exports__